export default __webpack_public_path__ + "static/media/QuATRo_Siegel_2023_Gruen.faf1dcac.svg";